import * as React from "react";
import { useState } from "react";
import useStyles from "src/app/maintenance/assets/styles";
import {
    Button,
    Divider,
    FormControl,
    FormHelperText,
    Grid,
    IconButton,
    NativeSelect,
    Typography,
} from "@material-ui/core";
import { createStyles, makeStyles, styled, Theme } from "@material-ui/core/styles";
import { primaryBlue, primaryGray, textBarColor, white, } from "src/components/colors";
import { BootstrapInput } from "../../product-types/add-new-firmware/steps/Step1";
import { environment } from "src/environments/environment";
import { AddIconTwo, DeleteIcon, EditIconTwo, ExpandIconTwo, ViewIconTwo } from "src/components/Icons";
import { DragDrop } from "src/components/sub-components/DragAndDrop";
import Dragger from "antd/lib/upload/Dragger";
import { UploadFile } from "antd/lib/upload/interface";

export default function AddVersionBinFile({
    setBinFile, binError,setBinError,
    setFlowChart=(undefined)=>{}, flowChartName="",
    setFlowChartName=({})=>{},
    flowchartFileList=[], 
    setFlowchartFileList= ([]) => {},
    flowChartError =  {error:false,errorMsg:""},
    setFlowChartError = ({}) => {},
    flowChartNameError = {error:false,errorMsg:""},
    setFlowChartNameError = undefined,
     setToaster,setReqSuccess,setErrorMessage,isFlowChartNeeded=false}) {
    const classes=localStyle();
    const [viewBaseVersion, setViewBaseVersion] = useState(false);
    const [viewFlowChat, setViewFlowChart] = useState(false);


    const [fileList, setFileList] = useState([])

    const style = useStyles();


    const toggleVisibility = (element) => {
        if (element == "baseVersion") {
            setViewBaseVersion(!viewBaseVersion);
        }
        else if (element == "flowChart") {
            setViewFlowChart(!viewFlowChat);
        }
    }
    const validateFileType = (
    { type, name }: UploadFile,
    allowedTypes?: string,
    endsWith?:string
  ) => {
    if (!allowedTypes) {
      return true;
    }

    if (type) {
      return allowedTypes.includes(type)&&(endsWith&&name.endsWith(endsWith))
    }
  };

    const uploadProps = {
        name: 'file',
        multiple: false,
        showUploadList: false, 
        maxCount: 1,  //not limiting the uploaded file count
        onChange(info) {
            const { status } = info.file;
            if (status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (info.fileList && info.fileList.length > 0) {
                let fileList = [...info.fileList];

                // Limit the number of uploaded files --> 1
                // old ones will be replaced by the new
                fileList = fileList.slice(-1);
                setFileList(fileList)
                const file = info.fileList[0].originFileObj;

                if (file) {
                    const isBin = validateFileType(file,"application/octet-stream",'.bin');
                    if (!isBin) {
                        setFileList([]);
                        setBinFile(null);
                        setReqSuccess(false);
                        setErrorMessage("Invalid file type");
                        setToaster(true);
                        return ;
                    }
                    setBinFile(file);
                    setBinError({error:false,errorMsg:""})
                }
            } else {
                setFileList([]);
                setBinFile(null);
            }
        },
    };

    const uploadPropsFlowChart = {
        name: 'fileFlowChart',
        multiple: false,
        maxCount: 1,  //not limiting the uploaded file count
        onChange(info) {
            const { status } = info.file;
            if (status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (info.fileList && info.fileList.length > 0) {
                let fileList = [...info.fileList];

                // 1. Limit the number of uploaded files --> 1
                // old ones will be replaced by the new
                fileList = fileList.slice(-1);
                setFlowchartFileList(fileList);
                const file = info.fileList[0].originFileObj;

                if (file) {
                    setFlowChart(file);
                    setFlowChartError({error:false,errorMsg:""})
                }
            } else {
                setFlowchartFileList([]);
                setFlowChart(null);
            }
        },
    };



    return (
        <>
      {/* <Grid container className={style.container} style={{backgroundColor:"whitesmoke",width:"100%",height:'100%'}}>

        //     <Grid item md={12} className={classes.menuContainer} >
        //         <Grid container className={classes.menuTitle}>
                   <Grid
                        item
                        xs={12}
                        md={12}
                        style={{ textAlign: "left" }}
                    >
                        <Typography style={{ paddingLeft: '20px' , fontWeight:"bold"}}>
                            Version
                        </Typography>
                    </Grid> */}
                    {/* <Grid item xs={1} md={1} style={{ textAlign: "left", paddingTop: "5px" }}>
                        <IconButton onClick={() => toggleVisibility('baseVersion')}>
                            <div className={style.subIconButtonDiv}>
                                <ExpandIconTwo rotation={viewBaseVersion} />
                            </div>
                        </IconButton>
                    </Grid> 
             </Grid>*/}
                <Grid container  style={{  alignItems: "center"}}>
                    <Grid item xs={12} md={12} >
                        <Typography className={style.typo}>
                            Upload Bin File
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={12} className={style.dragDrop} >
                        <Dragger {...uploadProps} accept='.bin' fileList={fileList}>
                            <Grid item style={{ justifyItems: 'center' }}>
                                <DragDrop />
                                <p className={style.dragText}> <span className={classes.blueText}>Choose a file </span>or drag & drop it here</p>
                                <p className="ant-upload-text" style={{ color: '#B4B2B2', textAlign: 'center' }}>maximum upload file size : 5MB</p>
                            </Grid>
                        </Dragger>
                        {fileList.length > 0 && (
                            <div className={style.flexCenterJustify}>
                            <span className={style.DragDropText}>{fileList[0].name}</span>
                            <span className={style.redCloseIcon} onClick={() => {setFileList([]);setBinFile(null);setBinError({error:false,serroMsg:""})}}>✕</span>
                            </div>
                        )}
                    </Grid>
                    {binError.error === true && (
                                   <span className="form-error">
                                    {binError.errorMsg}
                                  </span>
                                )}
                </Grid>
            {/* // </Grid> */}

            {isFlowChartNeeded &&
            <Grid item md={12} className={classes.menuContainer}  >
                <Grid container className={classes.menuTitle}>
                    <Grid
                        item
                        xs={5}
                        md={5}
                        style={{ textAlign: "left" }}
                    >
                        <Typography style={{ paddingLeft: '20px', fontWeight:"bold" }}>
                            Flow Chart
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={6}
                        md={6}
                        style={{ textAlign: "left", paddingTop: "20px" }}
                    >
                    </Grid>
                    <Grid item xs={1} md={1} style={{ textAlign: "left", paddingTop: "5px" }}>
                        <IconButton onClick={() => toggleVisibility('flowChart')}>
                            <div className={style.subIconButtonDiv}>
                                <ExpandIconTwo rotation={viewFlowChat} />
                            </div>
                        </IconButton>
                    </Grid>
                </Grid>
           
                <Grid container spacing={2} style={{display: viewFlowChat ? 'block' : 'none', alignItems: "center" }} >
                    <Grid item xs={12} md={12}>
                        <Typography className={style.typo}>
                           Flow chart file name
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <FormControl className={style.input}>
                            <input
                                className={style.formInput}
                                type="text"
                                placeholder="Enter Filename Here"
                                value={flowChartName}
                                onChange={(e) => {
                                    setFlowChartName(e.target.value);
                                    setFlowChartNameError({error:false,errorMsg:""});
                                }}
                            />
                        </FormControl>
                        {flowChartNameError.error === true && (
                            <span className="form-error">
                                {flowChartNameError.errorMsg}
                            </span>)}
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Typography className={style.typo}>
                            Upload Flowchart
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={12} className={style.dragDrop} style={{ width: '100%' }}>
                        <Dragger {...uploadPropsFlowChart} accept='.png,.jpg' fileList={flowchartFileList}>
                            <Grid item style={{ justifyItems: 'center' }}>
                                <DragDrop />
                                <p className={style.dragText}><span className={classes.blueText}>Choose a file </span>or drag & drop it here</p>
                                <p className="ant-upload-text" style={{ color: '#B4B2B2', textAlign: 'center' }}>maximum upload file size : 5MB</p>
                            </Grid>
                        </Dragger>
                    </Grid>
                    {flowChartError.error === true && (
                                   <span className="form-error">
                                    {flowChartError.errorMsg}
                                  </span>
                                )}
                </Grid>
                
            </Grid>}
        {/* // </Grid> */}
        </>
    )
}



const localStyle=makeStyles({
    blueText:{
        color: primaryBlue,
        cursor: 'pointer',
        textDecoration: 'underline', 
    },
    menuContainer:{
        marginBottom:"20px" ,
        backgroundColor:"white",
        width:"100%",
        padding:"10px",
        spacing:"2px"
    },
    menuTitle:{
        display:"flex",
        alignItems:"baseline"
    }
})